/* eslint-disable camelcase */
import React, { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import i18n from 'i18next';
import PropTypes from 'prop-types';

import { handleAxiosError } from 'core/notifications';

import axios from '@/util/axios';

import FileListItem from './fileListItem';

import getAxiosConfig from '../helpers/getAxiosConfig';

const transformData = ({ data }) => {
  const { name, cover_art } = data;
  const hasCoverArt = cover_art && cover_art.w550;

  return {
    name,
    ...(hasCoverArt && {
      image: {
        alt: i18n.t('catalog-activity-alt', { name }),
        src: cover_art.w550,
      },
    }),
  };
};

const CatalogActivityListItem = ({
  id,
  onRemove,
  defaultImage = null,
  showImage = false,
  status = '',
}) => {
  const queryKey = useMemo(() => ['catalog-activity', id], [id]);
  const { data, isSuccess } = useQuery({
    queryKey,
    queryFn: async () => (await axios(getAxiosConfig('get-course-properties', { id }))).data,
    onError: handleAxiosError,
    select: transformData,
  });

  const image = showImage && data?.image ? data?.image : defaultImage;

  return data && isSuccess ? (
    <FileListItem
      name={data?.name}
      materialType="Course"
      image={image}
      status={status}
      onRemove={onRemove}
    />
  ) : null;
};

CatalogActivityListItem.propTypes = {
  defaultImage: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.elementType,
  }),
  id: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
  status: PropTypes.oneOf([
    '',
    'created',
    'failure',
    'rag_token_requested',
    'request_file_transcript',
    'requested',
    'success',
  ]),
  showImage: PropTypes.bool,
};

export default CatalogActivityListItem;
